import "babel-polyfill";
import "whatwg-fetch";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import Amplify from "aws-amplify";
import { ConnectedRouter } from "connected-react-router";
import "antd/dist/antd.css";
import { store, history } from "./store";

const allConfigs: any = {
  development: {
    Auth: {
      region: "eu-central-1",
      userPoolId: "eu-central-1_klTQ2gKMg",
      userPoolWebClientId: "464knvm95cglbvgpisrjig246o"
    },
    API: {
      endpoints: [
        {
          name: "api",
          endpoint: "https://dev-api.forward-cargo.com"
        }
      ]
    }
  },
  staging: {
    Auth: {
      region: "eu-central-1",
      userPoolId: "eu-central-1_WyPUAlu43",
      userPoolWebClientId: "2m8n7uuhq7vmnhoduehk3dpoa3"
    },
    API: {
      endpoints: [
        {
          name: "api",
          endpoint: "https://staging-api.forward-cargo.com"
        }
      ]
    }
  },
  production: {
    Auth: {
      region: "eu-central-1",
      userPoolId: "eu-central-1_pOHJTMvI4",
      userPoolWebClientId: "32q8drq8jjd7f87b3vsqt2i3qp"
    },
    API: {
      endpoints: [
        {
          name: "api",
          endpoint: "https://api.forward-cargo.com"
        }
      ]
    }
  }
};

Amplify.configure(allConfigs[(process.env as any).REACT_APP_CUSTOM_STAGE]);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
